import {connect} from 'react-redux'
import React, {Component} from 'react'
import {Form, FormGroup} from '../component/form/form'
import {Portlet, PortletHead, PortletBody, PortletFooter} from '../component/widget/portlet'
import api from '../helper/api'
import localdata from '../helper/localdata'
import config from '../helper/config'
import swal from 'sweetalert'
import action from '../helper/action'
import do_action from '../action'

class TopupVA extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.update_current_page('topup')
    }

    render() {
        const container_style = {marginBottom: '30px'}
        const title_style = {fontWeight: 600,marginBottom: '15px',fontSize: '18px'}
        const content_style = {fontWeight: 500}
        const image_style = {marginLeft:'auto',marginRight:'auto',maxWidth: 200+'px',marginBottom: 20+'px',display: 'table-cell'}
        return (
            <div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="m-portlet">
                        <div className="m-portlet__body">
                            <article class="ac-text">
                                <img src="../swipe/img/bca.jpg" class="gopay-patform-icon" style={image_style}/>   
                                <div style={container_style}>
                                    <label style={title_style}>
                                        ATM BCA
                                    </label>
                                    <article>
                                        <ol>
                                            <li style={content_style}><p>Masukan kartu ATM dan PIN BCA anda</p></li>
                                            <li style={content_style}><p>Masuk ke menu transaksi lainnya</p></li>
                                            <li style={content_style}><p>Masukan kode bank untuk BNI:009 dan nomer rekening virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Masukan jumlah top up atau transfer yang diinginkan</p></li>
                                            <li style={content_style}><p>Ikuti instruksi untuk menyelesaikan transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up (transfer) minimum Rp.10.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>

                                <div style={container_style}>
                                    <label style={title_style}>
                                        KLIK BCA
                                    </label>
                                    <article>
                                        <ol>
                                            <li style={content_style}><p>Login ke klik BCA</p></li>
                                            <li style={content_style}><p>Pilih menu transfer dana  >  Transfer ke rekening bank lain dalam negeri </p></li>
                                            <li style={content_style}><p>Pilih nomer virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Masukan jumlah top up yang diinginkan</p></li>
                                            <li style={content_style}><p>Pilih jenis transfer</p></li>
                                            <li style={content_style}><p>Ikuti instruksi untuk menyelesaikan transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.10.000
                                        <br/>- Panduan diatas hanya jika rekening virtual account sudah didaftarkan
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>
                                
                                <div  style={container_style}>
                                    <label class="ac-label" style={{fontWeight:600}}>
                                        m-BCA (BCA MOBILE)
                                    </label>
                                    <article class="ac-sub-text">
                                        <ol class="custom-bullet custom-bullet--a">
                                            <li style={content_style}><p>Login ke m-BCA</p></li>
                                            <li style={content_style}><p>Pilih M-Transfer>Transfer antar bank</p></li>
                                            <li style={content_style}><p>Pilih 009-BNI, Pilih nomer rekening virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Masukan jumlah top up yang diinginkan</p></li>
                                            <li style={content_style}><p>Masukkan PIN m-BCA anda</p></li>
                                            <li style={content_style}><p>Ikuti Instruksi untuk menyelesaikan transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.10.000
                                        <br/>- Panduan diatas hanya jika rekening virtual account sudah didaftarkan
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>
                                
                            </article>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="m-portlet">
                        <div className="m-portlet__body">
                            <article class="ac-text">
                                <img src="../swipe/img/mandiri.png" class="gopay-patform-icon" style={image_style}/>   
                                <div style={container_style}>
                                    <label style={title_style}>
                                        ATM Mandiri
                                    </label>
                                    <article>
                                        <ol>
                                            <li style={content_style}><p>Masukan kartu ATM</p></li>
                                            <li style={content_style}><p>Pilih Bahasa indonesia</p></li>
                                            <li style={content_style}><p>Masukan PIN anda</p></li>
                                            <li style={content_style}><p>Masukan ke menu Transaksi lainnya > ke rek bank lain</p></li>
                                            <li style={content_style}><p>Masukan kode bank untuk BNI:009 dan nomer rekening virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Masukan jumlah top up atau transfer yang diinginkan</p></li>
                                            <li style={content_style}><p>Ikuti Instruksi untuk menyelesaikan Transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.15.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>

                                <div style={container_style}>
                                    <label style={title_style}>
                                        Mobile Banking Mandiri
                                    </label>
                                    <article>
                                        <ol>
                                            <li style={content_style}><p>Login ke mandiri mobile aplication</p></li>
                                            <li style={content_style}><p>Pilih Transfer > Online</p></li>
                                            <li style={content_style}><p>Masukan nomer rekening virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Masukan jumlah top up yang diinginkan</p></li>
                                            <li style={content_style}><p>Ikuti instruksi untuk menyelesaikan transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.15.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>
                                
                                <div  style={container_style}>
                                    <label class="ac-label" style={{fontWeight:600}}>
                                        Internet Banking Mandiri
                                    </label>
                                    <article class="ac-sub-text">
                                        <ol class="custom-bullet custom-bullet--a">
                                            <li style={content_style}><p>Login ke mandiri internet banking</p></li>
                                            <li style={content_style}><p>Pilih menu transfer > Antar bank Online</p></li>
                                            <li style={content_style}><p>Pilih rekening asal yang anda gunakan untuk transaksi masukan jumlah transfer</p></li>
                                            <li style={content_style}><p>Pilih bank penerima: BNI dan masukkan nomor rekening virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Ikuti instruksi untuk menyelesaikan transksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.15.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>
                                
                            </article>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-lg-6">
                    <div className="m-portlet">
                        <div className="m-portlet__body">
                            <article class="ac-text">
                                <img src="../swipe/img/bri.png" class="gopay-patform-icon" style={image_style}/>   
                                <div style={container_style}>
                                    <label style={title_style}>
                                        ATM BRI
                                    </label>
                                    <article>
                                        <ol>
                                            <li style={content_style}><p>Masukan kartu ATM</p></li>
                                            <li style={content_style}><p>Masukan PIN anda</p></li>
                                            <li style={content_style}><p>Pilih bahasa (contoh:indonesia)</p></li>
                                            <li style={content_style}><p>Masuk ke menu lain > ke bank lain</p></li>
                                            <li style={content_style}><p>Masukan kode bank untuk BNI:009 dan nomer rekening virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Masukan jumlah top up atau transfer yang diinginkan</p></li>
                                            <li style={content_style}><p>Ikuti instruksi untuk menyelesaikan transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.10.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>

                                <div style={container_style}>
                                    <label style={title_style}>
                                        BRI Mobile SMS
                                    </label>
                                    <article>
                                        <ol>
                                            <li style={content_style}><p>Transfer (spasi) Kodebank+nomer rekening virtual account anda (spasi) nominal top up/transfer (spasi) pin SMS banking</p></li>
                                            <li style={content_style}><p>Ikuti Instruksi untuk menyelesaikan transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.10.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>
                                
                                <div  style={container_style}>
                                    <label class="ac-label" style={{fontWeight:600}}>
                                        I-Banking BRI
                                    </label>
                                    <article class="ac-sub-text">
                                        <ol>
                                            <li style={content_style}><p>Login ke i-banking BRI</p></li>
                                            <li style={content_style}><p>Pilih menu transfer sesama dan antar bank</p></li>
                                            <li style={content_style}><p>Pilih transfer antar bank</p></li>
                                            <li style={content_style}><p>Pilih rekening pengirim (rekening BRI anda)</p></li>
                                            <li style={content_style}><p>Pilih bank tujuan BNI dan masukan nomer rekening virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Masukan jumlah top up atau transfer yang diinginkan</p></li>
                                            <li style={content_style}><p>Ikuti instruksi untuk menyelesaikan transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.10.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>
                                
                            </article>
                        </div>
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="m-portlet">
                        <div className="m-portlet__body">
                            <article class="ac-text">
                                <img src="../swipe/img/bni.jpg" class="gopay-patform-icon" style={image_style}/>   
                                <div style={container_style}>
                                    <label style={title_style}>
                                        ATM BNI
                                    </label>
                                    <article>
                                        <ol>
                                            <li style={content_style}><p>Masukan kartu ATM</p></li>
                                            <li style={content_style}><p>Pilih Bahasa indonesia</p></li>
                                            <li style={content_style}><p>Masukan PIN anda</p></li>
                                            <li style={content_style}><p>Masuk ke menu lainnya > Transfer</p></li>
                                            <li style={content_style}><p>Pilih dari rekening tabungan</p></li>
                                            <li style={content_style}><p>pilih ke rekening BNI</p></li>
                                            <li style={content_style}><p>Masukan nomer rekening virtual account anda (contoh:8763XXXXXXXXXXXX)</p></li>
                                            <li style={content_style}><p>Masukan jumlah top up atau ysng inginkan</p></li>
                                            <li style={content_style}><p>Ikuti Instruksi untuk meyelesaikan Transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.10.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>

                                <div style={container_style}>
                                    <label style={title_style}>
                                        BNI SMS
                                    </label>
                                    <article>
                                        <ol>
                                            <li style={content_style}><p>TRF (Spasi) Nomer rekening virtual account anda (Spasi) Nominal top up/Transfer kirim ke 3346</p></li>
                                            <li style={content_style}><p>Ikuti intruksi untuk menyelesaikan transaksi</p></li>
                                        </ol>
                                        <p className="text-danger" style={{fontSize: 'smaller'}}>Note :
                                        <br/>- Nilai top up minimum Rp.10.000
                                        <br/>- Biaya Rp.2000</p>
                                    </article>
                                </div>
                                
                            </article>
                        </div>
                    </div>
                </div>
            </div>

            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
    update_current_page:  val => dispatch(do_action(action.ACTION_UPDATE_CURRENT_PAGE, val))
})

export default connect(null, mapDispatchToProps)(TopupVA)



// WEBPACK FOOTER //
// ./src/component/topup.js